import(/* webpackMode: "eager" */ "/codebuild/output/src3612898653/src/easymeat-web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutProvider"] */ "/codebuild/output/src3612898653/src/easymeat-web/src/app/layoutProvider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3612898653/src/easymeat-web/src/styles/globals.css");
